import React, { useState } from 'react';
import api from '../services/api';

export default function ChangePassword({ onClose }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (next.length < 6) return setError('Le nouveau mot de passe doit faire au moins 6 caractères.');
    if (next !== confirm) return setError('La confirmation ne correspond pas.');
    setLoading(true);
    try {
      await api.post('/auth/change-password', { current_password: current, new_password: next });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Modifier mon mot de passe</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        {done ? (
          <div className="modal-body"><div className="badge-pill badge-success">Mot de passe mis à jour.</div></div>
        ) : (
          <form onSubmit={submit}>
            <div className="modal-body">
              <div className="form-group">
                <label>Mot de passe actuel</label>
                <input type="password" className="form-control" value={current} onChange={(e) => setCurrent(e.target.value)} />
              </div>
              <div className="form-group">
                <label>Nouveau mot de passe</label>
                <input type="password" className="form-control" value={next} onChange={(e) => setNext(e.target.value)} />
              </div>
              <div className="form-group">
                <label>Confirmer</label>
                <input type="password" className="form-control" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
              </div>
              {error && <div className="form-error">{error}</div>}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn-secondary" onClick={onClose}>Annuler</button>
              <button type="submit" className="btn-primary" disabled={loading}>{loading ? '…' : 'Enregistrer'}</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
